import http from "../index";

import PromoCode from "../../model/PromoCode";

export const getAllPromoCodes = () => http.get("/promo-code");
export const addPromoCode = (promocode: PromoCode) => http.post("/promo-code", promocode);
export const deletePromoCode = (code: string) => http.delete("/promo-code", {data: code});
